import { Box, Typography } from '@mui/material';

const InformationPorcentajes = ({
    text,
    styles,
    pstyles,
    onClick,
    fontSize = '14px',
    subText = '',
    ...props
}) => {
    const numericText = text > 0 || text === 0 ? text : 0;

    const getBackgroundColor = () => {
        if (numericText >= 90) {
            return '#1D6FB1 ';
        } else if (numericText >= 70) {
            return '#00793d';
        } else if (numericText >= 50) {
            return '#d45a00';
        } else {
            return '#BA3B3B';
        }
    };

    const getText = () => {
        return `${numericText}%`;
    };

    const handleLocalClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Box
            className="fixture-score-container__color"
            onClick={handleLocalClick}
            sx={{
                background: getBackgroundColor(),
                minWidth: '60px',
                border: '1px solid #ccc',
                height: '20px',
                fontSize: '12px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '4px',
                color: '#fff',
                marginTop: '4px',
                width: '100%',
                maxWidth: '80px',
                ...styles,
            }}
            {...props}
        >
            <Typography
                sx={{
                    margin: 0,
                    ...pstyles,
                    fontSize: fontSize,
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    textAlign: 'center',
                    overflow: 'hidden',
                    color: '#fff',
                }}
            >
                <Typography variant="span" style={{ fontSize: '12px' }}>
                    {subText}
                </Typography>
                {getText()}
            </Typography>
        </Box>
    );
};

export default InformationPorcentajes;
